exports = module.exports = require("../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports
exports.locals = {
	"menuText": "#fefefe",
	"menuActiveText": "#3c7ef6",
	"subMenuActiveText": "#fefefe",
	"menuBg": "transparent",
	"menuHover": "#fafcff",
	"subMenuBg": "transparent",
	"subMenuHover": "#fafcff",
	"sideBarWidth": "300px"
};